import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

export enum NotificationType {
    ERROR = 'error',
    WARNING = 'warning',
    INFO = 'info',
    SUCCESS = 'success',
}

export enum NotificationTopic {
    FMS = 'fms',
}

export interface Notification {
    topic: NotificationTopic;
    content: string;
    title: string;
    type: NotificationType;
    durationSeconds: number;
}

@Injectable({
    providedIn: 'root',
})
export class ToasterService {
    public notificationList$: BehaviorSubject<Notification[]> = new BehaviorSubject([]);

    public showNotification(notification: Notification): void {
        if (!this.getNotification(notification)) {
            this.notificationList$.next([notification, ...this.notificationList$.value]);
        }
    }

    public hideNotification(notification: Notification): void {
        this.notificationList$.next(this.notificationList$.value.filter((n) => n.topic !== notification.topic));
    }

    public getNotification(notification: Notification): Notification {
        const notifications = this.notificationList$.getValue();
        return notifications.find((n) => n.topic === notification.topic);
    }
}
